<template>
  <div>
    <div class="container-fluid cart-container">
      <div
        class="success_message"
        v-text="this.$root.success_message"
        v-if="this.$root.success_message != ''"
      ></div>
      <div
        class="error_message"
        v-text="this.$root.error_message"
        v-if="this.$root.error_message != ''"
      ></div>
      <div
        class="row"
        v-if="this.$root.cart_product.length != 0 && this.loader == false"
      >
        <div class="col-12">
          <h1 class="text-left font-medium cart-title">My Cart</h1>
        </div>
      </div>

      <div
        class="row"
        v-if="this.$root.cart_product.length != 0 && this.loader == false"
      >
        <div class="col-9 cart-table">
          <div v-if="offersAvailable.length > 0" class="offerAvail">
      
            <h4>
              <img src="img/offerIcon.png" class="img-responsive" alt="" />
              <span class="text-logo-color pl-2">{{
                offersAvailable.length
              }}</span>
              Offer{{ offersAvailable.length > 1 ? "s" : "" }} Available
            </h4>
            <ul class="cart-offer-list pl-4 my-2">
              <li v-if="showAllOffers == false">
                {{ offersAvailable[0].display_message }}-<strong>{{
                  offersAvailable[0].coupon_code
                }}</strong>
              </li>
              <span v-show="showAllOffers">
                
                <li
                  v-for="(item, index) in offersAvailable"
                  :key="`offers-${index}`"
                >
                  {{ item.display_message }}-<strong>{{
                    item.coupon_code
                  }}</strong>
                </li>
              </span>
            </ul>
            <a
              v-if="showAllOffers == false && offersAvailable.length > 1"
              @click="showAllOffers = true"
              href="javascript:void(0)"
              class="text-logo-color"
            >
              View All Offers <i class="fa fa-angle-down"></i
            ></a>
            <a
              v-if="showAllOffers == true && offersAvailable.length > 1"
              @click="showAllOffers = false"
              href="javascript:void(0)"
              class="text-logo-color"
            >
              Show Less <i class="fa fa-angle-up"></i
            ></a>
          
          </div>
          <!----><!---->
          <table class="cart table">
            <thead>
              <tr>
                <th class="item"><span>Item</span></th>
                <th class="qty text-center"><span>Qty</span></th>
                <th class="price text-right px-3"><span>Price</span></th>
                <th class="discount px-3"><span>Discount</span></th>
                <th class="subtotal px-3"><span>Subtotal</span></th>
              </tr>
            </thead>
            <tbody
              class="cart-item"
              v-for="(items, index) in this.$root.cart_product"
              :key="index"
            >
              <tr class="item-info" v-if="!items.is_grocery">
                <td class="item">
                  <div class="row">
                    <div class="col-4 col-md-3">
                      <router-link
                        :to="{
                          name: 'detail',
                          params: {
                            pro_id: items.id_product,
                            pro_url_key: items.url_key,
                          },
                          query: { store: items.store_id },
                        }"
                        class="item-photo"
                      >
                        <responsive-image
                          :alt="items.name"
                          :title="items.name"
                          v-bind:desktop="`${$root.image_url_c}inside/100x100/${items.image}`"
                          v-bind:tab="`${$root.image_url_c}inside/100x100/${items.image}`"
                          v-bind:mobile="`${$root.image_url_c}inside/100x100/${items.image}`"
                          v-bind:default_image="`${$root.image_url_c}inside/100x100/${items.image}`"
                        />
                      </router-link>
                    </div>
                    <div class="col-8 col-md-9">
                      <!-- <div class="storeName">
                        <span> {{ items.store_name.toLowerCase() }}</span>
                      </div> -->
                      <h2 class="item-name font-medium">
                        <router-link
                          :to="{
                            name: 'detail',
                            params: {
                              pro_id: items.id_product,
                              pro_url_key: items.url_key,
                            },
                            query: { store: items.store_id },
                          }"
                        >
                          {{ items.name }}</router-link
                        >
                      </h2>

                      <span class="storeName"
                        ><small class="storeName">Sold By</small>
                        {{ items.store_name.toLowerCase() }}</span
                      >
                      <p>
                        <strong class="forMobile">{{
                          items.price | formatMoney
                        }}</strong>
                      </p>
                      <!-- <p><del>Rs. 999</del> <span class="text-logo-color pl-2">54% Off</span></p> -->
                      <p
                        class="forMobile"
                        v-if="items.price != items.selling_price"
                      >
                        <span class="old_price">{{
                          (items.price * items.qty).toFixed(1) | formatMoney
                        }}</span>
                        <span class="selling_price">{{
                          (items.selling_price * items.qty).toFixed(1)
                            | formatMoney
                        }}</span>
                      </p>
                      <!---->
                      <p class="size" v-if="items.size">
                        <span class="font-medium">SIZE: </span
                        ><span class="size" v-text="items.size"></span>
                      </p>
                      <div class="control forMobile">
                        <div class="qty_box">
                          <a
                            href="#"
                            @click.prevent="qty_minus(items, index)"
                            v-bind:class="{ disabled: items.qty === 1 }"
                            ><i class="fa fa-minus"></i
                          ></a>
                          <input type="text" :value="items.qty" readonly />
                          <a
                            href="#"
                            @click.prevent="qty_plus(items, index)"
                            v-bind:class="{
                              max_disabled: items.qty >= items.max_qty,
                              max_disabled: items.qty >= 5,
                            }"
                            ><i class="fa fa-plus"></i
                          ></a>
                        </div>
                        <p
                          class="font-medium mobile-qty-msg text-center"
                          style="
                            color: #02bb02;
                            font-size: 12px;
                            margin-top: 3px;
                          "
                          v-if="items.qty === 1 && items.max_qty === '1'"
                        >
                          Only 1 item is left.
                        </p>
                        <!---->
                      </div>
                      <div class="mobileBottomCart forDesktop">
                        <a
                          href="#"
                          @click.prevent="deleteEvent(items)"
                          title="Remove"
                          class="remove-cart"
                          id="remove-cart"
                        >
                          <span> Remove </span></a
                        >
                        <a
                          style="left: 100px"
                          href="#"
                          title="Remove"
                          class="remove-cart"
                        >
                          <span
                            @click.prevent="addToWishList(items.id_product)"
                          >
                            Move to Wishlist
                          </span></a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="mobileBottomCart forMobile">
                    <a
                      href="#"
                      @click.prevent="deleteEvent(items)"
                      title="Remove"
                      class="remove-cart remove-button"
                      id="remove-cart"
                    >
                      <span> Remove </span></a
                    >
                    <a
                      style="left: 100px"
                      href="#"
                      title="Remove"
                      class="remove-cart"
                    >
                      <span @click.prevent="addToWishList(items.id_product)">
                        Move to Wishlist
                      </span></a
                    >
                  </div>
                </td>

                <td class="qty">
                  <div class="control forDesktop">
                    <div class="qty_box m-auto">
                      <a
                        href="#"
                        @click.prevent="qty_minus(items, index)"
                        v-bind:class="{ disabled: items.qty === 1 }"
                        ><i class="fa fa-minus"></i></a
                      ><input type="text" :value="items.qty" readonly />
                      <a
                        @click.prevent="qty_plus(items, index)"
                        href="#"
                        v-bind:class="{
                          max_disabled: items.qty >= items.max_qty,
                          max_disabled: items.qty >= 5,
                        }"
                        ><i class="fa fa-plus"></i
                      ></a>
                    </div>
                    <p
                      class="font-medium mobile-qty-msg text-center"
                      style="color: #02bb02; font-size: 12px; margin-top: 3px"
                      v-if="items.qty === 1 && items.max_qty === '1'"
                    >
                      Only 1 item is left.
                    </p>
                    <!---->
                  </div>
                </td>
                <td class="price text-right px-4">
                  <p class="forDesktop">{{ items.price | formatMoney }}</p>
                </td>
                <td class="discount text-right px-4">
                  <p
                    v-if="
                      items.price * items.qty == items.selling_price * items.qty
                    "
                    class="forDesktop"
                  >
                    0
                  </p>

                  <p v-else class="forDesktop">
                    {{
                      (
                        items.price * items.qty -
                        items.selling_price * items.qty
                      ).toFixed(1) | formatMoney
                    }}
                  </p>
                </td>
                <td class="subtotal text-right">
                  <p class="forDesktop">
                    <span class="selling_price">{{
                      (items.selling_price * items.qty).toFixed(1) | formatMoney
                    }}</span>
                  </p>
                </td>
              </tr>
            </tbody>

            <tbody class="groderyCartBg" v-if="isGrocery">
              <tr>
                <td
                  colspan="5"
                  style="
                    border: none;
                    font-size: 22px;
                    font-family: 'lhmRegular';
                    padding: 5px 15px;
                  "
                >
                  Grocery
                </td>
              </tr>
            </tbody>
            <tbody
              class="cart-item"
              v-if="items.is_grocery"
              v-for="(items, index) in this.$root.cart_product"
              :key="index + 'gro'"
            >
              <tr class="item-info" v-if="items.is_grocery">
                <td class="item">
                  <div class="row">
                    <div class="col-4 col-md-3">
                      <router-link
                        :to="{
                          name: 'detail',
                          params: {
                            pro_id: items.id_product,
                            pro_url_key: items.url_key,
                          },
                          query: { store: items.store_id },
                        }"
                        class="item-photo"
                      >
                        <responsive-image
                          :alt="items.name"
                          :title="items.name"
                          v-bind:desktop="`${$root.image_url_c}inside/100x100/${items.image}`"
                          v-bind:tab="`${$root.image_url_c}inside/100x100/${items.image}`"
                          v-bind:mobile="`${$root.image_url_c}inside/100x100/${items.image}`"
                          v-bind:default_image="`${$root.image_url_c}inside/100x100/${items.image}`"
                        />
                      </router-link>
                    </div>
                    <div class="col-8 col-md-9">
                      <h2 class="item-name font-medium">
                        <router-link
                          :to="{
                            name: 'detail',
                            params: {
                              pro_id: items.id_product,
                              pro_url_key: items.url_key,
                            },
                            query: { store: items.store_id },
                          }"
                        >
                          {{ items.name }}</router-link
                        >
                      </h2>
                      <span class="storeName"
                        >Sold By {{ items.store_name.toLowerCase() }}</span
                      >

                      <p>
                        <strong class="forMobile">{{
                          items.price | formatMoney
                        }}</strong>
                      </p>
                      <!-- <p><del>Rs. 999</del> <span class="text-logo-color pl-2">54% Off</span></p> -->
                      <p
                        class="forMobile"
                        v-if="items.price != items.selling_price"
                      >
                        <span class="old_price">{{
                          (items.price * items.qty).toFixed(1) | formatMoney
                        }}</span>
                        <span class="selling_price">{{
                          (items.selling_price * items.qty).toFixed(1)
                            | formatMoney
                        }}</span>
                      </p>
                      <!---->
                      <p class="size" v-if="items.size">
                        <span class="font-medium">SIZE: </span
                        ><span class="size" v-text="items.size"></span>
                      </p>
                      <div class="control forMobile">
                        <div class="qty_box">
                          <a
                            href="#"
                            @click.prevent="qty_minus(items, index)"
                            v-bind:class="{ disabled: items.qty === 1 }"
                            ><i class="fa fa-minus"></i
                          ></a>
                          <input type="text" :value="items.qty" readonly />
                          <a
                            href="#"
                            @click.prevent="qty_plus(items, index)"
                            v-bind:class="{
                              max_disabled: items.qty >= items.max_qty,
                              max_disabled: items.qty >= 5,
                            }"
                            ><i class="fa fa-plus"></i
                          ></a>
                        </div>
                        <p
                          class="font-medium mobile-qty-msg text-center"
                          style="
                            color: #02bb02;
                            font-size: 12px;
                            margin-top: 3px;
                          "
                          v-if="items.qty === 1 && items.max_qty === '1'"
                        >
                          Only 1 item is left.
                        </p>
                        <!---->
                      </div>
                      <div class="mobileBottomCart forDesktop">
                        <a
                          href="#"
                          @click.prevent="deleteEvent(items)"
                          title="Remove"
                          class="remove-cart"
                          id="remove-cart"
                        >
                          <span> Remove </span></a
                        >
                        <a
                          style="left: 100px"
                          href="#"
                          title="Remove"
                          class="remove-cart"
                        >
                          <span
                            @click.prevent="addToWishList(items.id_product)"
                          >
                            Move to Wishlist
                          </span></a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="mobileBottomCart forMobile">
                    <a
                      href="#"
                      @click.prevent="deleteEvent(items)"
                      title="Remove"
                      class="remove-cart"
                      id="remove-cart"
                    >
                      <span> Remove </span></a
                    >
                    <a
                      style="left: 100px"
                      href="#"
                      title="Remove"
                      class="remove-cart"
                    >
                      <span @click.prevent="addToWishList(items.id_product)">
                        Move to Wishlist
                      </span></a
                    >
                  </div>
                </td>

                <td class="qty px-4">
                  <div class="control forDesktop">
                    <div class="qty_box m-auto">
                      <a
                        href="#"
                        @click.prevent="qty_minus(items, index)"
                        v-bind:class="{ disabled: items.qty === 1 }"
                        ><i class="fa fa-minus"></i></a
                      ><input type="text" :value="items.qty" readonly /><a
                        href="#"
                        @click.prevent="qty_plus(items, index)"
                        v-bind:class="{
                          max_disabled: items.qty >= items.max_qty,
                          max_disabled: items.qty >= 5,
                        }"
                        ><i class="fa fa-plus"></i
                      ></a>
                    </div>
                    <p
                      class="font-medium mobile-qty-msg text-center"
                      style="color: #02bb02; font-size: 12px; margin-top: 3px"
                      v-if="items.qty === 1 && items.max_qty === '1'"
                    >
                      Only 1 item is left.
                    </p>
                    <!---->
                  </div>
                </td>
                <td class="price px-4 text-right">
                  <p class="forDesktop">{{ items.price | formatMoney }}</p>
                </td>
                <td class="discount px-4 text-right">
                  <p
                    v-if="
                      items.price * items.qty == items.selling_price * items.qty
                    "
                    class="forDesktop"
                  >
                    0
                  </p>

                  <p v-else class="forDesktop">
                    {{
                      (
                        items.price * items.qty -
                        items.selling_price * items.qty
                      ).toFixed(1) | formatMoney
                    }}
                  </p>
                </td>
                <td class="subtotal text-right">
                  <p class="forDesktop">
                    <span class="selling_price">{{
                      (items.selling_price * items.qty).toFixed(1) | formatMoney
                    }}</span>
                  </p>
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td colspan="5">
                  <a href="/" class="continue main-btn-outline float-left"
                    >Continue Shopping</a
                  >
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="col-3 cart-summary">
          <div class="discount-container">
            <label class="label discount-label font-medium forDesktop"
              ><span>Order Summary</span></label
            >
            <!-- <div class="coupon-container">
							<p class="coupon-heading pull-left font-medium"> Apply Coupons </p>
							<div class="actions-toolbar pull-right">
								<button type="button" class="coupon-popup add-coupon" style="">
									<span>Add Coupon</span>
								</button>
							</div>
						</div> -->
            <div class="discount-container checkout_sidebar">
              <div>
                <div class="coupon-container">
                  <p class="coupon-heading pull-left font-medium">
                    Apply Coupons
                    <!---->
                  </p>

                  <div class="actions-toolbar pull-right">
                    <button
                      type="button"
                      class="coupon-popup add-coupon"
                      @click="toggleCoupon()"
                    >
                      <span>Add Coupons</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="discount-message"></div>
          </div>
          <div class="">
            <h3 class="forMobile p-2"><strong>Your Order Summary</strong></h3>
            <div class="container mt-3 pb-5">
              <!-- cart details commented -->

              <!-- <div class="row summaryHeadRow py-2">
								<div class="col-8 pl-0">PRODUCT</div>
								
							</div> 
							<div class="row borderDiv py-1"></div>
							<div class="row py-1 summarProductDetail"
								v-for="(items, i) in this.$root.cart_product"
								:key="i" >
								<div class="col-8 pl-0">{{ items.name }}</div>
								<div class="col-4 pr-0 text-right"> {{ items.price | formatMoney }}</div>
							</div> -->

              <!-- cart details commented end here -->

              <div class="row py-1 summarDiscountDetail">
                <div class="col-8 pl-0">Total MRP</div>
                <div class="col-4 pr-0 text-right">
                  <span>{{ $root.summary.totalMRP | formatMoney }}</span>
                </div>
              </div>
              <div class="row py-1 summarDiscountDetail">
                <div class="col-8 pl-0">Total discount on MRP</div>
                <div class="col-4 pr-0 text-right">
                  <span>{{ $root.summary.discountMRP | formatMoney }}</span>
                </div>
              </div>
              <!-- <div class="row py-1 summarDiscountDetail">
								<div class="col-8 pl-0">SubTotal</div>
								<div class="col-4 pr-0 text-right">
									<span >{{$root.cart_subtotal | formatMoney}}</span> 
								</div>
							</div> -->
              <!-- <div class="row py-1 summarDiscountDetail">
								<div class="col-8 pl-0">Total Discount on MRP</div>
								<div class="col-4 pr-0 text-right">
									<span >{{$root.summary.discountMRP | formatMoney}}</span> 
								</div>
							</div> -->
              <div class="row py-1 summarDiscountDetail">
                <div class="col-8 pl-0">Shipping Charges</div>
                <div class="col-4 pr-0 text-right">
                  <span>{{ this.$root.shipping_charge | formatMoney }}</span>
                </div>
              </div>
              <div class="row py-1 summarDiscountDetail">
                <div class="col-8 pl-0">Coupon Discount</div>
                <div class="col-4 pr-0 text-right">
                  <span v-if="$root.discount_amount">
                    {{ $root.discount_amount | formatMoney }}
                  </span>
                  <span v-else> <span>&#8377;</span> 0 </span>
                </div>
              </div>
              <!-- <div class="remove-coupon" >
							<p class="coupon-heading pull-left font-medium " v-for="coupon in applied_coupon_arr" :key="coupon" v-if="applied_coupon_arr.length>0">
						     	<a style="cursor: pointer" @click="remove_coupon(coupon)">
								  <span> {{ coupon }}</span> <i class="fa fa-times-circle"></i>
								</a>
							</p>		
							</div>
						</div> -->
              <!-- <div class="row py-1 summarDiscountDetail">
								<div class="col-8 pl-0">Discount on MRP</div>
								<div class="col-4 pr-0 text-right discount-color">- Rs. {{ this.$root. }}</div>
							</div> -->

              <!-- <div class="row py-1 summarDiscountDetail">
								<div class="col-8 pl-0">Platform Handling Fee <i class="fa fa-info"></i> </div>
								<div class="col-4 pr-0 text-right">- 0</div>
							</div> -->
              <!-- <div class="row py-1 summarDiscountDetail">
								<div class="col-8 pl-0">Coupon Discount <strong class="text-success">HDFC Card</strong></div>
								<div class="col-4 pr-0 text-right text-success"> <strong> - Rs. 20 </strong> </div>
							</div> -->
              <div class="row borderDiv py-1"></div>
              <div class="row py-2">
                <div class="col-8 pl-0"><strong>Total Amount</strong></div>
                <div class="col-4 pr-0 text-right">
                  <strong
                    ><span>{{ this.$root.cart_total | formatMoney }}</span>
                  </strong>
                </div>
              </div>
            </div>
            <div>
              <div v-if="applied_coupon_arr.length > 0" class="remove-coupon">
                <p
                  class="coupon-heading pull-left font-medium"
                  v-for="coupon in applied_coupon_arr"
                  :key="coupon.coupon_code + Math.random()"
                >
                  <a style="cursor: pointer" @click="remove_coupon(coupon)">
                    <span> {{ coupon.coupon_code }}</span>
                    <i class="fa fa-times-circle"></i>
                  </a>
                </p>
              </div>
            </div>
            <div class="cartFixedBtn">
              <button class="mobileFixedBtn forMobile">Submit</button>
            </div>
          </div>
          <div class="checkout-container">
            <a href="/checkout.html" class="newFixBtn"
              ><button type="button" class="checkout font-medium w-100">
                <span>Checkout</span>
              </button></a
            >
          </div>
        </div>
      </div>
      <div
        class="row"
        v-if="this.$root.cart_product.length == 0 && this.loader == false"
      >
        <div class="col-12 text-center emptyCartContainer">
          <img class="emptyCart" src="img/emptyCart.png" />
          <br />
          <h3>Ohh.. Your cart is empty</h3>
          <p>Looks like you haven’t made your choice yet !</p>
          <div class="cartFixBtn">
            <button class="btn thankuShopping" @click="$router.push('/')">
              Shop Now
            </button>
          </div>

          <!-- <router-link
							:to="{ path: '/', name: 'Home' }"
							v-ripple
							:key="0"
							v-if="this.continue_path === '' || this.continue_path === null"
							><span>Click here</span>
						</router-link> -->
          <!-- <router-link
							:to="{ path: this.continue_path }"
							v-ripple
							:key="0"
							v-else
							><span>Click here</span>
						</router-link>
						to continue shopping. -->
        </div>
      </div>

      <!-- <div class="row" v-if="this.loader == true">
        <div class="col-12 text-center emptyCartContainer">
          <loading-icon
            class="loading-icon newLoader"
            name="ball-clip-rotate-multiple"
            color="#ba2126"
            scale="1"
          ></loading-icon> -->
          <!-- <img class="emptyCart" src="img/emptyCart.png" />
          <br />
          <h3>Ohh.. Your cart is empty</h3>
          <p>Looks like you haven’t made your choice yet !</p>
          <div class="cartFixBtn">
            <button class="btn thankuShopping" @click="$router.push('/')">
              Shop Now
            </button>
          </div> -->
        <!-- </div>
      </div> -->
    </div>

    <!--apply coupon popup loader-->

    <div
      class="modal"
      style="z-index: 1100"
      v-bind:class="[this.coupon_process ? 'active' : '']"
      id="coupon-modal"
    >
      <loading-icon
        class="loading-icon applyCouponloader"
        name="ball-clip-rotate-multiple"
        color="red"
        scale="1"
      ></loading-icon>
    </div>
    

    <!--coupon popup start here-->
    <div
      class="modal"
      v-bind:class="[this.coupon_popup ? '' : 'active']"
      id="coupon-modal"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header p-4">
            <h4 class="modal-title font-bold">APPLY COUPON</h4>
            <button type="button" class="close" @click="close_popup()">
              &times;
            </button>
          </div>
          <!-- Modal body -->
          <div
            class="modal-body p-4"
            style="max-height: 80vh; overflow-y: auto"
          >
            <div class="couponsForm-base-couponsPageContainer">
              <div role="tablist">
                <div
                  class="block discount active"
                  id="block-discount"
                  data-collapsible="true"
                  role="tab"
                  aria-selected="true"
                  aria-expanded="true"
                  tabindex="0"
                >
                  <div id="discount-coupon-form">
                    <div class="fieldset coupon">
                      <input
                        type="hidden"
                        name="remove"
                        id="remove-coupon"
                        value="0"
                      />
                      <input
                        name="form_key"
                        type="hidden"
                        value="KsjDpCfcgYHw5MOG"
                      />
                      <div class="couponsForm-base-formContainer">
                        <div class="couponsForm-base-textInputContainer">
                          <input
                            id="coupon_code"
                            class="couponsForm-base-textInput"
                            v-model="applied_coupon"
                            name="coupon_code"
                            placeholder="Enter coupon code"
                            autocomplete="off"
                          />
                          <button
                            v-ripple
                            @click="apply_coupon_typed()"
                            class="
                              action
                              apply
                              primary
                              couponsForm-base-applyButton
                              font-medium
                            "
                            id="applycoupon"
                            type="button"
                          >
                            <span>Apply</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="couponsForm-base-errorMessage"></div>
              </div>
              <div class="couponsForm-base-boundary"></div>
              <div
                class="couponsForm-base-container"
                v-if="this.coupon_list.length != 0"
              >
                <div class="couponsForm-base-couponsTitle">
                  Best coupon for you
                </div>
                <div
                  v-for="(store, storeName) in this.coupon_list"
                  :key="storeName"
                >
                  <div class="store-name">{{ storeName }}</div>
                  <div
                    class="
                      coupon-base-validCoupon coupon-base-validCouponContainer1
                    "
                    v-for="(item, index) in store"
                    :key="`coupon${index}`"
                  >
                    <div class="coupons-container">
                      <div class="coupon-base-couponCode font-bold">
                        {{ item.coupon_code }}
                      </div>
                      <div
                        v-if="checkAppliedCoupon(item)"
                        class="coupon-base-apply font-medium"
                        @click="apply_coupon(item)"
                      >
                        <i
                          v-if="couponProcessing.includes(item)"
                          class="fa fa-spinner fa-spin"
                        ></i>
                        <span v-else>Apply</span>
                      </div>
                      <div class="coupon-base-benefit">
                        <span class="coupon-base-amount font-medium"
                          ><span class="icon-rupee coupon-base-rupeeIcon"></span
                          >{{ item.display_message }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="couponsForm-base-container">
                <div class="text-center p-5">No Coupons available</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--coupon popup end here-->
        <div class="skelten loading" v-if="this.loader == true" >
          <PuSkeleton width="100%" height="60px">
          </PuSkeleton>
              <div class="cart-div">

                  <div class="cartInfoSkeleton">
                  <PuSkeleton class="Skeletonitem Skeletonitem1" height="inherit" style="padding:0 ; " >
                  </PuSkeleton>
                  <PuSkeleton  class="Skeletonitem Skeletonitem2" height="inherit" style="padding:0">
                  </PuSkeleton>
                  <PuSkeleton class="Skeletonitem Skeletonitem4 "  height='inherit'>
                  </PuSkeleton>
                  </div> 
                  
                  <div class="SummarySkeleton">
                  <PuSkeleton class="Skeletonitem Skeletonitem3"  height='inherit'>
                  </PuSkeleton>
                  
                  </div>
                 
              </div>
        </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Cart",

  computed: {
    isGrocery() {
      let isGrocery = false;
      this.$root.cart_product.forEach((x) => {
        if (x.is_grocery) {
          isGrocery = true;
          return isGrocery;
        }
      });
      return isGrocery;
    },
    offersAvailable() {
      let offers = [];
        let storecouon=[];
          let platformcoupon=[];
          let allcoupon=[];
      if (this.coupon_list) {
        // for (const [key, value] of Object.entries(this.coupon_list)) {
        //   offers.push(...value);
        // }
         for (let key in this.coupon_list) {
                  
                 if(key=='WNDW'){
                   platformcoupon.push(...this.coupon_list[key])
                 }
                 else{
                   let reverseofstorecouon=this.coupon_list[key].reverse()
                    storecouon.push(...reverseofstorecouon)
                 }
            }
          
           platformcoupon=platformcoupon.reverse()
            allcoupon=[...storecouon, ...platformcoupon]
           offers.push(...allcoupon);
      }
      return offers;
    },
  },
  metaInfo: {
    title: "Cart",
    meta: [
      {
        name: "description",
        content:
          "Online fashion shopping destination for the modern women. Buy latest collection of online ethnic wear for women’s, W Kurtas, dresses, bottom wear, tops, palazzos, culottes, skirts, drapes and more.",
      },
      {
        property: "keywords",
        content:
          "Online Shopping for Women,  W for Woman, women’s dresses online, buy women’s dresses online",
      },
    ],
  },
  data() {
    return {
      
      coupon_process: false,
      loader: true,
      coupon_list: [],
      applied_coupon_arr: [],
      couponProcessing: [],
      showAllOffers: false,
      net_amount: "",
      continue_path: "",
      coupon_popup: true,
      applied_coupon: "",
      shipping_charges: "",
      cod_charges: "",
      free_offer: false,
      free_offer_sku: [
        "19AUW9HB0002-43168",
        "19AUW9HB0002-43167",
        "20FEW93098-43164",
        "20FEW93098-43163",
        "20FEW93096-43087",
        "20FEW93096-43086",
        "20FEW93095-43085",
        "20FEW93094-43084",
        "20FEW93094-43083",
        "20FEW93090-43162",
        "20FEW93090-43161",
        "20FEW93089-43280",
        "20FEW93089-43159",
        "20FEW93089-43158",
        "20FEW93089-43157",
        "20FEW93089-43156",
        "20FEW93089-43155",
        "20FEW93088-43154",
        "20FEW93088-43153",
        "20FEW93087-43152",
        "20FEW93087-43151",
        "20FEW93085-43148",
        "20FEW93085-43147",
        "20FEW93084-43146",
        "20FEW93084-43145",
        "20FEW93084-43144",
        "20FEW93083-43143",
        "20FEW93083-43142",
        "20FEW93082-43141",
        "20FEW93082-43140",
        "20FEW93081-43139",
        "20FEW93081-43138",
        "20FEW93080-43170",
        "20FEW93080-43137",
        "20FEW93080-43136",
        "20FEW93078-43169",
        "20FEW93078-43134",
        "20FEW93078-43133",
        "20FEW93076-43131",
        "20FEW93075-43130",
        "20FEW93075-43129",
        "20FEW93075-43128",
        "20FEW93074-43127",
        "20FEW93074-43126",
        "20FEW93074-43125",
        "20FEW93073-43124",
        "20FEW93072-43123",
        "20FEW93072-43122",
        "20FEW93071-43121",
        "20FEW93070-43120",
        "20FEW93070-43119",
        "20FEW93070-43118",
        "20FEW93069-43117",
        "20FEW93069-43116",
        "20FEW93068-43115",
        "20FEW93067-43114",
        "20FEW93066-43113",
        "20FEW93066-43112",
        "20FEW93066-43111",
        "20FEW93065-43110",
        "20FEW93064-43109",
        "20FEW93064-43108",
        "20FEW93063-43107",
        "20FEW93062-43106",
        "20FEW93060-43104",
        "20FEW93058-43209",
        "20FEW93058-43208",
        "20FEW93058-43207",
        "20FEW93058-43206",
        "20FEW93058-43205",
        "20FEW93058-43103",
        "20FEW93058-43102",
        "20FEW93056-43100",
        "20FEW93056-43099",
        "20FEW93055-43098",
        "20FEW93055-43097",
        "20FEW93054-43096",
        "20FEW93054-43095",
        "20FEW93053-43093",
        "20FEW93053-43092",
        "20FEW93052-43091",
        "20FEW93052-43090",
        "20FEW93050-43089",
      ],
    };
  },
  methods: {
    
    checkAppliedCoupon(coupon) {
      let status = true;
      this.applied_coupon_arr.forEach((x) => {
        if (x.coupon_code == coupon.coupon_code && x.store == coupon.store) {
          status = false;
        }
      });
      return status;
    },
    toggleCoupon() {
      // console.log("called");
      this.coupon_popup = !this.coupon_popup;
    },
    apply_coupon_typed() {
      // console.log("called");
      Object.values(this.coupon_list).map((item) => {
        // console.log(item);
        let store = item.filter((element) => {
          return (
            element.coupon_code.toLowerCase() ==
            this.applied_coupon.toLowerCase()
          );
        });
        if (store.length > 0) {
          this.apply_coupon(store[0]);
        } else {
          this.$root.error_message = "No Such Coupon Available";
        }
      });
    },
    getCouponList() {
      
      let storeList = [];
      this.$root.cart_product.forEach((product) => {
        if (storeList.includes(product.store_id) === false) {
          storeList.push(product.store_id);
        }
        // console.log(storeList);
      });
      storeList = storeList.join("-");

      axios
        .get(this.$root.api_url + "/pim/promotions/listapi.php", {
          params: {
            type: "coupons",
            s: storeList,
          },
        })
        .then((res) => {
          this.coupon_list = res.data;
           this.loader = false;
        }).catch(err =>{
           this.loader = false;
        });
        
    },
    formatDiscountPrice(value) {
      let val;
      return (val = (value / 1).toFixed(0).replace(",", ","));
    },
    addToWishList(id) {
      // console.log("callrd");
      if (!this.$root.customer_id) {
        this.$root.login_popup = true;
      } else {
        var form = new FormData();
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("type", "add");
        form.append("product_id", id);
        axios
          .post(this.$root.cart_api + `/wishlist/add-to-wishlist`, form)
          .then((res) => {
            if (res.data.success) {
              //   this.productsInWishlist.push(parseInt(id));

              this.$root.wishListProducts = this.$root.wishListProducts + 1;
              this.$toast.success(res.data.message, {
                position: "top-right",
                duration: 4000,
              });
            } else {
              this.$toast.error("Product already exits in wishlist", {
                position: "top-right",
                duration: 4000,
              });
            }
          })
          .catch((err) => {
            this.$toast.error("Something went wrong", {
              position: "top-right",
              duration: 4000,
            });
            //this.$root.error_message = err.data.message
          });
      }
      // console.log(id);
    },
    groupByKey(array, key) {
      return array.reduce((hash, obj) => {
        if (obj[key] === undefined) return hash;
        return Object.assign(hash, {
          [obj[key]]: (hash[obj[key]] || []).concat(obj),
        });
      }, {});
    },
    get_cart: function () {
      
      
      if (this.$root.pcart != null && this.$root.pcart != "") {
        var form = new FormData();
        form.append("pcart", this.$root.pcart);
        form.append("cart_session", this.$root.cart_session);
        axios
          .post(this.$root.cart_api + "/cart/get-cart", form)
          .then((response) => {
            if (response.data.success === true) {
              this.$root.shipping_charge = response.data.shippingCharge;
              this.$root.cart_total = response.data.grandTotal;
              this.$root.cart_subtotal = response.data.subTotal;
              this.$root.cart_netAmount = response.data.netAmount;
              this.$root.discount_amount = response.data.discountAmount;

              if (this.$root.pcart === null) {
                this.$root.pcart = response.data.pcart;
              }
              if (response.data.data.length > 0) {
                let ProductsArray = [];
                // Sorting Products array according to SKU
                response.data.data.forEach((cart) => {
                  ProductsArray = [...ProductsArray, ...cart.products];

                  if (cart.cookieDelete === 1) {
                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cart",
                      ""
                    );
                    this.$root.pcart = "";
                  }
                  if (
                    cart.discount_code != "" &&
                    cart.discount_code != null &&
                    cart.discount_by != "platform"
                  ) {
                    let coupon = {
                      store: cart.store,
                      coupon_code: cart.discount_code,
                    };
                    this.applied_coupon_arr.push(coupon);
                  }
                  if (cart.discount_by == "platform") {
                    let coupon = {
                      store: 0,
                      coupon_code: cart.discount_code,
                    };
                    if (this.applied_coupon_arr.length == 0) {
                      this.applied_coupon_arr.push(coupon);
                    }
                  }
                });

                this.$root.cart_product = ProductsArray;
                this.getCouponList();
                // this.loader = false;

              } else {
                this.loader = false;
                this.$root.cart_product = [];
                this.$root.shipping_charge = response.data.shippingCharge;
                this.$root.cart_total = response.data.grandTotal;
                this.$root.cart_subtotal = response.data.subTotal;
                this.$root.cart_netAmount = response.data.netAmount;
                this.$root.discount_amount = response.data.discountAmount;

                //  this.$store.dispatch('getCart', response.data.data.products)
              }

              // if (response.data.data.cookieDelete === 1) {
              // 	$cookies.set(
              // 		window.location.hostname.substring(10, 4) + "_cart",
              // 		""
              // 	);
              // 	this.$root.pcart = "";
              // }
              // if(this.$root.address.length != 0){
              //   for(let i = 0; i < this.$root.address.length; i++){
              //     if(i == 0)
              //     {
              //       this.$root.address_id = this.$root.address[i].id*1;
              //       this.$root.select_address_no = i;
              //     }
              //   }
              // }
   
            } else {
              if (
                response.data.customer_session_status == false ||
                response.data.cart_session_status == false
              ) {
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                this.$root.pcart = "";
                this.$root.cart_session = "";
                this.$root.cart_product = [];
              }
            }
            // this.loader = false;
          })
          .catch((error) => {
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
      }
    },

    checkout_gtm: function () {
      // this.$gtm.trackEvent({
      //     event: 'checkout',
      //     category: 'Ecommerce',
      //     action: 'Checkout',
      //     label: '1',
      //     ecommerce: {
      //         currencyCode: 'INR',
      //         checkout: {
      //             'actionField': { 'step': 1, 'option': this.$root.login_status },
      //             product: this.$root.gtm_product,
      //         }
      //     }
      // });
    },
    deleteEvent: function (product) {
      this.$root.error_message = "";
      this.$root.success_message = "";
      this.$root.page_loader = true;
      var form = new FormData();
      form.append("pcart", this.$root.pcart);
      form.append("cart_id", product.order_quote_id);
      form.append("product_id", product.variant_id);
      axios
        .post(this.$root.cart_api + "/product/remove-product", form)
        .then((response) => {
          if (response.data.success === true) {
            this.$root.page_loader = false;
            this.$toast.success(response.data.message, {
              position: "top",
              duration: 4000,
            });
            this.$root.shipping_charge = response.data.shippingCharge;
            this.$root.cart_total = response.data.grandTotal;
            this.$root.cart_subtotal = response.data.subTotal;
            this.$root.cart_netAmount = response.data.netAmount;
            this.$root.discount_amount = response.data.discountAmount;

            if (this.$root.pcart === null) {
              this.$root.pcart = response.data.pcart;
            }
            if (response.data.data.length > 0) {
              let ProductsArray = [];
              // Sorting Products array according to SKU
              this.applied_coupon_arr = [];

              response.data.data.forEach((cart) => {
                ProductsArray = [...ProductsArray, ...cart.products];

                if (cart.cookieDelete === 1) {
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cart",
                    ""
                  );
                  this.$root.pcart = "";
                }
                if (
                  cart.discount_code != "" &&
                  cart.discount_code != null &&
                  cart.discount_by != "platform"
                ) {
                  let coupon = {
                    store: cart.store,
                    coupon_code: cart.discount_code,
                  };
                  this.applied_coupon_arr.push(coupon);
                }
                if (cart.discount_by == "platform") {
                  let coupon = {
                    store: 0,
                    coupon_code: cart.discount_code,
                  };
                  if (this.applied_coupon_arr.length == 0) {
                    this.applied_coupon_arr.push(coupon);
                  }
                }
              });

              this.$root.cart_product = ProductsArray;
            } else {
              this.$root.cart_product = [];
              this.$root.shipping_charge = response.data.shippingCharge;
              this.$root.cart_total = response.data.grandTotal;
              this.$root.cart_subtotal = response.data.subTotal;
              this.$root.cart_netAmount = response.data.netAmount;
              this.$root.discount_amount = response.data.discountAmount;

              //  this.$store.dispatch('getCart', response.data.data.products)
            }

            this.$root.error_message = "";
          } else {
            this.$root.page_loader = false;
            this.$root.error_message = response.data.message;
            this.$root.success_message = "";
            if (response.data.cart_session_status == false) {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cs",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                "",
                "1y"
              );
              this.$root.pcart = "";
              this.$root.cart_session = "";
              this.$root.cart_product = [];
            }
          }
        })
        .catch((error) => {
          this.$root.page_loader = false;
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
          window.scrollTo(0, 0);
        });
    },
    formatPrice(value, precision = false) {
      let val;

      if (precision) val = (value / 1).toFixed(2).replace(",", ",");
      else val = (value / 1).toFixed(0).replace(",", ",");

      return `<span>&#8377;</span> ${val
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        .replace(".00", "<small>.00</small>")} `;
    },
    qty_plus(product, index) {
      // console.log("called plus");
      //console.log("product",product);

      //console.log("this.$root.cart_product[index]",this.$root.cart_product[index]);
      this.$root.error_message = "";
      this.$root.success_message = "";
      var current_qty = product.qty;
      // console.log(product.max_qty);
      // current_qty < product.max_qty &&
      if (current_qty < 5) {
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("qty_ordered", 1);
        form.append("product_id", product.variant_id);
        form.append("cart_id", product.order_quote_id);
        form.append("pcart", this.$root.pcart);
        form.append("type", "add");
        form.append("item_id", product.item_id);
        form.append("latitude", this.$root.location.lat);
        form.append("longitude", this.$root.location.long);
        // form.append("cart_session",this.$root.cart_session);
        axios
          .post(this.$root.cart_api + "/product/update-product", form)
          .then((response) => {
            if (response.data.success === true) {
              this.$root.page_loader = false;
              //   console.log(this.$root.cart_product[index]);
              // this.$root.cart_product[index]["qty"] =  this.$root.cart_product[index].qty +1
              //  this.$root.cart_total =+product.price
              //     this.$root.cart_subtotal =+ product.selling_price
              //     this.$root.cart_netAmount =+ product.net_amount
              // console.log(this.$root.cart_product[index].qty);
              this.get_cart();

              //   //Code for multi cart add

              //  if(this.$root.pcart===null){
              //      this.$root.pcart = response.data.data.pcart
              //     }

              // if(response.data.data.products.length>0){
              //   //Products Array
              //     let ProductsArray = []
              // Sorting Products array according to SKU
              //    this.$root.cart_total= 0
              //    this.$root.cart_subtotal = 0
              //    this.$root.cart_netAmount = 0
              // response.data.data.forEach(products=>{
              // this.$root.cart_total = this.$root.cart_total + products.grand_total
              // this.$root.cart_subtotal = this.$root.cart_subtotal+ products.order_subtotal
              // this.$root.cart_netAmount = this.$root.cart_netAmount+ products.net_amount

              //     let sortedProducts = this.groupByKey(response.data.data.products, 'sku')
              // // Creating Sorted Products Array
              //         Object.keys(sortedProducts).map(function(key, index) {
              //         ProductsArray.push(sortedProducts[key])
              //         });
              // })
              // console.log(ProductsArray);
              // Modifying Price and Quantity accroding to SKU
              //     let data = []
              //     let price = 0
              //     ProductsArray.forEach((ele,index)=>{

              //      let qty=0
              //         ele.forEach(product=>{
              //             qty = qty + product.qty
              //              ele[0]["qty"] = qty
              //         })
              //         data.push(ele[0])
              //     })
              //     console.log(data);
              //     this.$root.cart_product[index] = data
              // }
              // else{

              //     this.$root.cart_total=response.data.data.grand_total,
              //         // net_amount:response.data.data.net_amount,
              //         this.$root.cart_subtotal=response.data.data.order_subtotal
              //     // products = response.data.data.products
              //     // this.$store.dispatch('getAmount', amount)
              //  this.get_cart()
              //     // this.$root.cart_product = response.data.data.products
              //     //  this.$store.dispatch('getCart', response.data.data.products)
              // }

              // this.$root.cart_product = response.data.data.products;
              // this.$root.cart_total = response.data.data.grand_total;
              // this.$root.cart_subtotal = response.data.data.order_subtotal;
              // this.$root.discount_code = response.data.data.discount_code;
              // this.net_amount = response.data.data.net_amount;
              // this.applied_coupon = response.data.data.discount_code;
              // this.cod_charges = response.data.data.cod_charge;
              // this.shipping_charges = response.data.data.shipping_charges;
              // this.$root.discount_amount = response.data.data.discount_amount;
              // this.$root.success_message = response.data.message;
              // this.$root.error_message = '';
            } else {
              this.$root.page_loader = false;
              this.$toast.error(response.data.message, {
                position: "top",
                duration: 4000,
              });
              // this.$root.error_message = response.data.message;
              this.$root.success_message = "";
              if (response.data.cart_session_status == false) {
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                this.$root.pcart = "";
                this.$root.cart_session = "";
                this.$root.cart_product = [];
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
      }
    },
    qty_minus(product, index) {
      this.$root.error_message = "";
      this.$root.success_message = "";
      var current_qty = product.qty;
      if (current_qty > 1) {
        // this.$root.cart_product[index].qty = current_qty - 1;
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("qty_ordered", 1);
        form.append("product_id", product.variant_id);
        form.append("cart_id", product.order_quote_id);
        form.append("pcart", this.$root.pcart);
        form.append("type", "remove");
        form.append("item_id", product.item_id);
        form.append("latitude", this.$root.location.lat);
        form.append("longitude", this.$root.location.long);
        axios
          .post(this.$root.cart_api + "/product/update-product", form)
          .then((response) => {
            if (response.data.success === true) {
              this.$root.page_loader = false;

              // this.$root.cart_product[index]["qty"] =  this.$root.cart_product[index].qty - 1
              this.get_cart();
              //Code for multi cart add

              //  if(this.$root.pcart===null){
              //      this.$root.pcart = response.data.data.pcart
              //     }

              // if(response.data.data.length>0){
              //   //Products Array
              //     let ProductsArray = []
              //     // Sorting Products array according to SKU
              //    this.$root.cart_total= 0
              //    this.$root.cart_subtotal = 0
              //    this.$root.cart_netAmount = 0
              //     response.data.data.forEach(products=>{
              //         this.$root.cart_total = this.$root.cart_total + products.grand_total
              //         this.$root.cart_subtotal = this.$root.cart_subtotal+ products.order_subtotal
              //         this.$root.cart_netAmount = this.$root.cart_netAmount+ products.net_amount

              //         let sortedProducts = this.groupByKey(products.products, 'sku')
              //     // Creating Sorted Products Array
              //             Object.keys(sortedProducts).map(function(key, index) {
              //             ProductsArray.push(sortedProducts[key])
              //             });
              //     })

              //     // Modifying Price and Quantity accroding to SKU
              //     let data = []
              //     let price = 0
              //     ProductsArray.forEach((ele,index)=>{
              //      let qty=0
              //         ele.forEach(product=>{
              //             qty = qty + product.qty
              //              ele[0]["qty"] = qty
              //         })
              //         data.push(ele[0])
              //     })
              //     this.$root.cart_product = data
              // }
              // else{

              //     this.$root.cart_total=response.data.data.grand_total,
              //         // net_amount:response.data.data.net_amount,
              //         this.$root.cart_subtotal=response.data.data.order_subtotal
              //     // products = response.data.data.products
              //     // this.$store.dispatch('getAmount', amount)
              //  this.get_cart()
              //     // this.$root.cart_product = response.data.data.products
              //     //  this.$store.dispatch('getCart', response.data.data.products)
              // }
              // this.$root.cart_product = response.data.data.products;
              // this.$root.cart_total = response.data.data.grand_total;
              // this.net_amount = response.data.data.net_amount;
              // this.$root.cart_subtotal = response.data.data.order_subtotal;
              // this.$root.discount_code = response.data.data.discount_code;
              // this.cod_charges = response.data.data.cod_charge;
              // this.shipping_charges = response.data.data.shipping_charges;
              // this.applied_coupon = response.data.data.discount_code;
              // this.$root.discount_amount = response.data.data.discount_amount;
              this.$toast.success(response.data.message, {
                position: "top",
                duration: 4000,
              });
              // this.$root.success_message = response.data.message;
              this.$root.error_message = "";
            } else {
              this.$root.page_loader = false;
              this.$toast.error(response.data.message, {
                position: "top",
                duration: 4000,
              });
              // this.$root.error_message = response.data.message;
              this.$root.success_message = "";
              if (response.data.cart_session_status == false) {
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                this.$root.pcart = "";
                this.$root.cart_session = "";
                this.$root.cart_product = [];
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
      }
    },
    qtychange: function (index) {
      this.$root.error_message = "";
      this.$root.success_message = "";
      this.$root.page_loader = true;
      this.$root.cart_product[index].qty = event.target.value;
      var form = new FormData();
      form.append("qty_ordered", this.$root.cart_product[index].qty);
      form.append("product_id", this.$root.cart_product[index].variant_id);
      form.append("pcart", this.$root.pcart);
      axios
        .post(this.$root.cart_api + "/product/update-product", form)
        .then((response) => {
          if (response.data.success === true) {
            this.$root.shipping_charge = response.data.shippingCharge;
            this.$root.cart_total = response.data.grandTotal;
            this.$root.cart_subtotal = response.data.subTotal;
            this.$root.cart_netAmount = response.data.netAmount;
            this.$root.discount_amount = response.data.discountAmount;
            if (this.$root.pcart === null) {
              this.$root.pcart = response.data.pcart;
            }
            if (response.data.data.length > 0) {
              let ProductsArray = [];
              // Sorting Products array according to SKU

              response.data.data.forEach((cart) => {
                ProductsArray = [...ProductsArray, ...cart.products];

                if (cart.cookieDelete === 1) {
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cart",
                    ""
                  );
                  this.$root.pcart = "";
                }
              });

              this.$root.cart_product = ProductsArray;
            } else {
              this.$root.cart_product = [];
              this.$root.shipping_charge = response.data.shippingCharge;
              this.$root.cart_total = response.data.grandTotal;
              this.$root.cart_subtotal = response.data.subTotal;
              this.$root.cart_netAmount = response.data.netAmount;
              this.$root.discount_amount = response.data.discountAmount;

              //  this.$store.dispatch('getCart', response.data.data.products)
            }
          } else {
            this.$root.page_loader = false;
            this.$root.error_message = response.data.message;
            this.$root.success_message = "";
          }
        })
        .catch((error) => {
          this.$root.page_loader = false;
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
          window.scrollTo(0, 0);
        });
    },
    addcoupon: function () {
      this.applied_coupon = "";
      this.coupon_popup = false;
      this.$root.error_message = "";
      this.$root.success_message = "";
    },
    close_popup: function () {
      this.coupon_popup = true;
    },
    // free_bag(coupon) {
    // 	this.applied_coupon = "";
    // 	this.coupon_popup = false;
    // 	this.$root.error_message = "";
    // 	this.$root.success_message = "";
    // 	this.applied_coupon = coupon;
    // 	this.apply_coupon();
    // },
    apply_coupon(coupon) {
      this.coupon_process = true;
     
      this.couponProcessing.push(coupon);
      // console.log(e);
      // e.preventDefault();
      this.$root.page_loader = true;
    
      var form = new FormData();
      form.append("pcart", this.$root.pcart);
      form.append("cart_session", this.$root.cart_session);
      form.append("coupon", coupon.coupon_code);
      form.append("store", coupon.store);
      this.$root.error_message = "";
      this.$root.success_message = "";
      // this.coupon_e_m = "";
      // this.coupon_s_m = "";

      axios
        .post(this.$root.cart_api + "/cart/assign-coupon", form)
        .then((response) => {
          if (response.data.success === true) {
            // console.log(response.data.discountAmount);
            this.applied_coupon_arr.push(coupon);
            this.coupon_process = false;
            this.coupon_popup = true;
            this.couponProcessing = [];
            this.applied_coupon = "";
            this.$root.page_loader = false;
            this.$root.shipping_charge = response.data.shippingCharge;
            this.$root.cart_total = response.data.grandTotal;
            this.$root.cart_subtotal = response.data.subTotal;
            this.$root.cart_netAmount = response.data.netAmount;
            this.$root.discount_amount = response.data.discountAmount;
            if (this.$root.pcart === null) {
              this.$root.pcart = response.data.pcart;
            }
            if (response.data.data.length > 0) {
              let ProductsArray = [];
              this.applied_coupon_arr = [];
              // Sorting Products array according to SKU

              response.data.data.forEach((cart) => {
                ProductsArray = [...ProductsArray, ...cart.products];

                if (cart.cookieDelete === 1) {
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cart",
                    ""
                  );
                  this.$root.pcart = "";
                }
                if (
                  cart.discount_code != "" &&
                  cart.discount_code != null &&
                  cart.discount_by != "platform"
                ) {
                  let coupon = {
                    store: cart.store,
                    coupon_code: cart.discount_code,
                  };
                  this.applied_coupon_arr.push(coupon);
                }
                if (cart.discount_by == "platform") {
                  let coupon = {
                    store: 0,
                    coupon_code: cart.discount_code,
                  };
                  if (this.applied_coupon_arr.length == 0) {
                    this.applied_coupon_arr.push(coupon);
                  }
                }
              });

              this.$root.cart_product = ProductsArray;
            } else {
              this.$root.cart_product = [];
              this.$root.shipping_charge = response.data.shippingCharge;
              this.$root.cart_total = response.data.grandTotal;
              this.$root.cart_subtotal = response.data.subTotal;
              this.$root.cart_netAmount = response.data.netAmount;
              this.$root.discount_amount = response.data.discountAmount;

              //  this.$store.dispatch('getCart', response.data.data.products)
            }

            this.$toast.success(response.data.message, {
              position: "top",
              duration: 4000,
            });
            this.$root.error_message = "";
          } else {
            this.$toast.error(response.data.message, {
              position: "top",
              duration: 4000,
            });
            this.$root.page_loader = false;
            // this.coupon_s_m = "";
            // this.coupon_e_m = response.data.message;
            if (response.data.cart_session_status == false) {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cs",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                "",
                "1y"
              );
              // this.$root.pcart = '';
              this.$root.cart_session = "";
              this.$root.cart_product = [];
              this.$router.push("/cart.html");
            }
          }
        })
        .catch((error) => {
          this.$root.page_loader = false;

          if (error.message === "Network Error") {
            this.$toast.error(
              "Oops there seems to be some Network issue, please try again.",
              {
                position: "top",
                duration: 4000,
              }
            );
            // this.$root.error_message =
            // 	"Oops there seems to be some Network issue, please try again.";
          }
          window.scrollTo(0, 0);
        });
    },
    remove_coupon: function (rcoupon) {
      this.$root.page_loader = true;
      var form = new FormData();
      form.append("pcart", this.$root.pcart);
      form.append("store", rcoupon.store);
      form.append("coupon_code", rcoupon.coupon_code);
      this.$root.error_message = "";
      this.$root.success_message = "";

      axios
        .post(this.$root.cart_api + "/cart/remove-coupon", form)
        .then((response) => {
          if (response.data.success === true) {
            this.$root.page_loader = false;
            this.$root.error_message = "";
            this.$root.shipping_charge = response.data.shippingCharge;
            this.$root.cart_total = response.data.grandTotal;
            this.$root.cart_subtotal = response.data.subTotal;
            this.$root.cart_netAmount = response.data.netAmount;
            this.$root.discount_amount = response.data.discountAmount;
            this.$toast.warning("Coupon removed successfully", {
              position: "top",
              duration: 4000,
            });
            if (this.$root.pcart === null) {
              this.$root.pcart = response.data.pcart;
            }
            if (response.data.data.length > 0) {
              let ProductsArray = [];
              this.applied_coupon_arr = [];
              // Sorting Products array according to SKU

              response.data.data.forEach((cart) => {
                ProductsArray = [...ProductsArray, ...cart.products];

                if (cart.cookieDelete === 1) {
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cart",
                    ""
                  );
                  this.$root.pcart = "";
                }
                if (
                  cart.discount_code != "" &&
                  cart.discount_code != null &&
                  cart.discount_by != "platform"
                ) {
                  let coupon = {
                    store: cart.store,
                    coupon_code: cart.discount_code,
                  };
                  this.applied_coupon_arr.push(coupon);
                }
                if (cart.discount_by == "platform") {
                  let coupon = {
                    store: 0,
                    coupon_code: cart.discount_code,
                  };
                  if (this.applied_coupon_arr.length == 0) {
                    this.applied_coupon_arr.push(coupon);
                  }
                }
              });
              this.$root.cart_product = [];

              this.$root.cart_product = ProductsArray;
            } else {
              this.$root.cart_product = [];
              this.$root.shipping_charge = response.data.shippingCharge;
              this.$root.cart_total = response.data.grandTotal;
              this.$root.cart_subtotal = response.data.subTotal;
              this.$root.cart_netAmount = response.data.netAmount;
              this.$root.discount_amount = response.data.discountAmount;

              //  this.$store.dispatch('getCart', response.data.data.products)
            }

            this.applied_coupon_arr = this.applied_coupon_arr.filter((x, i) => {
              if (
                x.coupon_code == rcoupon.coupon_code &&
                x.store == rcoupon.store
              ) {
              } else {
                return x;
              }
            });
          } else {
            this.$root.page_loader = false;
            this.$root.success_message = "";
            this.coupon_e_m = response.data.message;
            this.$toast.error(response.data.message, {
              position: "top-right",
              duration: 4000,
            });
            if (response.data.cart_session_status == false) {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cs",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                "",
                "1y"
              );
              // this.$root.pcart = '';
              this.$root.cart_session = "";
              this.$root.cart_product = [];
              this.$router.push("/cart.html");
            }
          }
        })
        .catch((error) => {
          this.$root.page_loader = false;
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
          window.scrollTo(0, 0);
        });
    },
  },
  mounted() {
    console.log("this.$root.cart_total",this.$root.cart_total)
    this.$root.error_message = "";
    this.$root.success_message = "";
  },
  beforeMount() {
    this.$root.page_loader = true;
    this.get_cart();

    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode == 27) {
        this.coupon_popup = true;
      }
    });
  },
  created() {
    let bodyTag = document.getElementsByTagName("body");
    bodyTag[0].classList.add("m_bottom");

    window.scrollTo(0, 0);
    this.$root.minicart = true;
    this.continue_path = $cookies.get(
      window.location.hostname.substring(10, 4) + "_last_list_path"
    );
  },
};
</script>
<style scoped>
.applyCouponloader {
  position: relative;
  top: 50%;
  left: 50%;
}


.skelten.loading{
   width: 97vw;
  /* justify-content: center */
  margin:0 auto;
}
.cart-div{
   /* display: grid; */
  /* grid-template-columns: 1fr 1fr 1fr; */
  /* row-gap: 22px; */
  /* column-gap: 4px;   */
  /* display: flex;*/
  display: flex;
  gap: 15px;  
}
.cartInfoSkeleton {
  width: 65%;
}
.SummarySkeleton {
  width: 35%;
}

.cart-div .Skeletonitem.Skeletonitem1 {
  /* grid-column: 1 / span 2; */
  height: 115px;
  display: block;
  margin-bottom: 20px;
 }


.cart-div .Skeletonitem.Skeletonitem4 { 
  display: none;
}
.cart-div .Skeletonitem.Skeletonitem2 {
  height: 271px;
  display: block;
    /* grid-column: 1 / span 2; */

}


/* .cart-div .Skeletonitem.Skeletonitem4 { */
  /* height: 0px; */
    /* grid-column: 1 / span 2; */
    /* width: 30%; */
  
/* } */
.cart-div .Skeletonitem.Skeletonitem3 {
    /* grid-column: 3/4 !important; */
    /* grid-row: 1/4; */
    height: 441px;
}

/* .cart-table {
  min-height: 600px;
} */

  @media screen and (max-width: 767px) {

    .cart-div {
       display: block;
    }
    .cartInfoSkeleton {
  width: 100%;
}
.SummarySkeleton {
  width: 100%;
}
.cart-div .Skeletonitem.Skeletonitem1 {
  height: 145px;
  margin-bottom: 4px;
}
.cart-div .Skeletonitem.Skeletonitem2 {
  height: 221px;
  margin-bottom: 4px;

}
.cart-div .Skeletonitem.Skeletonitem4 { 
    display: block;
    height: 102px;
  margin-bottom: 4px;

}
.cart-div .Skeletonitem.Skeletonitem3 {
  height: 240px;
}
  }
    
  

</style>